module.exports = __webpack_public_path__ + "img/2_2-finanziario-stazione-1.c456f5dd.png";